/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetInventoryListItemDto } from './AssetInventoryListItemDto';
import {
    AssetInventoryListItemDtoFromJSON,
    AssetInventoryListItemDtoFromJSONTyped,
    AssetInventoryListItemDtoToJSON,
    AssetInventoryListItemDtoToJSONTyped,
} from './AssetInventoryListItemDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Paginated Integrations asset inventory list (REQ-INV-06)
 * @export
 * @interface AssetInventoryListResponse
 */
export interface AssetInventoryListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventoryListResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<AssetInventoryListItemDto>}
     * @memberof AssetInventoryListResponse
     */
    data?: Array<AssetInventoryListItemDto>;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListResponse
     */
    observationBacklogPending?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryListResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryListResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AssetInventoryListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AssetInventoryListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the AssetInventoryListResponse interface.
 */
export function instanceOfAssetInventoryListResponse(value: object): value is AssetInventoryListResponse {
    return true;
}

export function AssetInventoryListResponseFromJSON(json: any): AssetInventoryListResponse {
    return AssetInventoryListResponseFromJSONTyped(json, false);
}

export function AssetInventoryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AssetInventoryListItemDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'observationBacklogPending': json['observationBacklogPending'] == null ? undefined : json['observationBacklogPending'],
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function AssetInventoryListResponseToJSON(json: any): AssetInventoryListResponse {
    return AssetInventoryListResponseToJSONTyped(json, false);
}

export function AssetInventoryListResponseToJSONTyped(value?: AssetInventoryListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AssetInventoryListItemDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'observationBacklogPending': value['observationBacklogPending'],
        'queryDurationMs': value['queryDurationMs'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

